import { render, staticRenderFns } from "./order-constructopr.vue?vue&type=template&id=39d4e7fe&"
import script from "./order-constructopr.vue?vue&type=script&lang=ts&"
export * from "./order-constructopr.vue?vue&type=script&lang=ts&"
import style0 from "./order-constructopr.vue?vue&type=style&index=0&id=39d4e7fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports